import { sortOptions } from "../mocks/sort.mocks"

export const get = (obj, path, def) => {
  const fullPath = path
    .replace(/\[/g, ".")
    .replace(/]/g, "")
    .split(".")
    .filter(Boolean)
  return fullPath.every(everyFunc) ? obj : def
  function everyFunc(step) {
    return !(step && obj && (obj = obj[step]) === undefined)
  }
}

// deep cloning object to avoid object reference
export const deepCloneSimpleObject = obj => {
  if (obj) return JSON.parse(JSON.stringify(obj))
}

export const deslashify = origUrl => {
  const url = origUrl?.trim().endsWith("/") ? origUrl.slice(0, -1) : origUrl
  return url
}
// adding this function to remove expressions from slug
export const replaceAll = (str, find, replace) => {
  const expression = find.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  return str?.replace(new RegExp(expression, "g"), replace)
}

const getLoc = (data, countryListData) => {
  let result = []
  let locName
  let countryName
  let locId
  data?.map(itm => {
    locId = itm
    countryListData?.map(country => {
      country?.locations?.length > 0 &&
        country?.locations?.map(location => {
          if (location?.value == itm) {
            locName = location?.label
            countryName = country?.countryName
          }
        })
    })
    result.push({
      locName: locName,
      countryName: countryName,
      locId: itm,
    })
  })
  return result
}

export const getLocDets = (data, countryListData = []) => {
  const primLoc =
    data?.Primary_Location_Reference.length > 0 &&
    getLoc(data?.Primary_Location_Reference, countryListData)
  return primLoc
}

export const getFuncName = (lab, filterListData = []) => {
  let currentFunc = ""
  const functions = filterListData?.selectFields?.jobFamily?.options
  functions?.map(itm => {
    if (itm?.value?.split("|")?.includes(lab)) {
      currentFunc = itm?.label
    }
  })
  return currentFunc
}

export const isBrowser = () => typeof window !== "undefined"

export const isElement = (elem) => {
  return elem instanceof Element;
}

export const scrollIntoViewIfNeeded = (elem) => {
  if (isElement(elem)) {
    const rectElem = elem.getBoundingClientRect()
    if (rectElem.bottom > window.innerHeight) elem.scrollIntoView(false);
    else if (rectElem.top < 0) elem.scrollIntoView();
  }
}

export const getSourceDomain = (sourceSiteURL, utmParams) => {
  let sourceResult = null
  if (utmParams?.toLowerCase()?.includes("utm_source=email")) {
    if (utmParams?.toLowerCase()?.includes("utm_medium=phenom_newslette"))
      sourceResult = "CRM_Candidate"
    else sourceResult = "CRM_Candidate"
  }
  else if (utmParams?.toLowerCase()?.includes("utm_medium=paid")) {
    if (utmParams?.toLowerCase()?.includes("utm_source=google"))
      sourceResult = "APPLICANT_SOURCE-6-115"
    else if (utmParams?.toLowerCase()?.includes("utm_source=linkedin"))
      sourceResult = "APPLICANT_SOURCE-6-112"
    else if (utmParams?.toLowerCase()?.includes("utm_source=facebook"))
      sourceResult = "APPLICANT_SOURCE-6-113"
    else if (utmParams?.toLowerCase()?.includes("utm_source=tiktok"))
      sourceResult = "APPLICANT_SOURCE-6-114"
    else if (utmParams?.toLowerCase()?.includes("utm_source=instagram"))
      sourceResult = "APPLICANT_SOURCE-6-116"
    else
      sourceResult = "APPLICANT_SOURCE-6-117"
  }
  else {
    if (sourceSiteURL?.toLowerCase()?.includes("google")) {
      sourceResult = "Google"
    } else if (sourceSiteURL?.toLowerCase()?.includes("naukri")) {
      sourceResult = "APPLICANT_SOURCE-3-59"
    } else if (sourceSiteURL?.toLowerCase()?.includes("monster")) {
      sourceResult = "APPLICANT_SOURCE-3-53"
    } else if (sourceSiteURL?.toLowerCase()?.includes("indeed")) {
      sourceResult = "APPLICANT_SOURCE-3-71"
    } else if (sourceSiteURL?.toLowerCase()?.includes("linkedin")) {
      sourceResult = "APPLICANT_SOURCE-3-39"
    } else if (sourceSiteURL?.toLowerCase()?.includes("bumeran")) {
      sourceResult = "APPLICANT_SOURCE-3-43"
    } else if (sourceSiteURL?.toLowerCase()?.includes("zonajobs")) {
      sourceResult = "APPLICANT_SOURCE-3-46"
    } else if (sourceSiteURL?.toLowerCase()?.includes("vegas")) {
      sourceResult = "APPLICANT_SOURCE-3-47"
    } else if (sourceSiteURL?.toLowerCase()?.includes("pcdonline")) {
      sourceResult = "APPLICANT_SOURCE-3-48"
    } else if (sourceSiteURL?.toLowerCase()?.includes("equitek")) {
      sourceResult = "APPLICANT_SOURCE-3-49"
    } else if (sourceSiteURL?.toLowerCase()?.includes("nbmbaa")) {
      sourceResult = "APPLICANT_SOURCE-3-50"
    } else if (sourceSiteURL?.toLowerCase()?.includes("prospanica")) {
      sourceResult = "APPLICANT_SOURCE-3-51"
    } else if (sourceSiteURL?.toLowerCase()?.includes("drive my way")) {
      sourceResult = "APPLICANT_SOURCE-3-52"
    } else if (sourceSiteURL?.toLowerCase()?.includes("monster")) {
      sourceResult = "APPLICANT_SOURCE-3-53"
    } else if (sourceSiteURL?.toLowerCase()?.includes("careerbuilder")) {
      sourceResult = "APPLICANT_SOURCE-3-54"
    } else if (sourceSiteURL?.toLowerCase()?.includes("craigslist")) {
      sourceResult = "APPLICANT_SOURCE-3-55"
    } else if (sourceSiteURL?.toLowerCase()?.includes("seek")) {
      sourceResult = "APPLICANT_SOURCE-3-56"
    } else if (sourceSiteURL?.toLowerCase()?.includes("gradconnection")) {
      sourceResult = "APPLICANT_SOURCE-3-57"
    } else if (sourceSiteURL?.toLowerCase()?.includes("student job board")) {
      sourceResult = "APPLICANT_SOURCE-3-58"
    } else if (sourceSiteURL?.toLowerCase()?.includes("naukri.com")) {
      sourceResult = "APPLICANT_SOURCE-3-59"
    } else if (sourceSiteURL?.toLowerCase()?.includes("iimjobs")) {
      sourceResult = "APPLICANT_SOURCE-3-60"
    } else if (sourceSiteURL?.toLowerCase()?.includes("totaljobs")) {
      sourceResult = "APPLICANT_SOURCE-3-61"
    } else if (sourceSiteURL?.toLowerCase()?.includes("cadremploi")) {
      sourceResult = "APPLICANT_SOURCE-3-62"
    } else if (sourceSiteURL?.toLowerCase()?.includes("infojobs")) {
      sourceResult = "APPLICANT_SOURCE-3-63"
    } else if (sourceSiteURL?.toLowerCase()?.includes("praca")) {
      sourceResult = "APPLICANT_SOURCE-3-64"
    } else if (sourceSiteURL?.toLowerCase()?.includes("jobs.cz")) {
      sourceResult = "APPLICANT_SOURCE-3-65"
    } else if (sourceSiteURL?.toLowerCase()?.includes("profesia.sk")) {
      sourceResult = "APPLICANT_SOURCE-3-66"
    } else if (sourceSiteURL?.toLowerCase()?.includes("stepstone")) {
      sourceResult = "APPLICANT_SOURCE-3-67"
    } else if (sourceSiteURL?.toLowerCase()?.includes("finn")) {
      sourceResult = "APPLICANT_SOURCE-3-68"
    } else if (sourceSiteURL?.toLowerCase()?.includes("irishjobs.ie")) {
      sourceResult = "APPLICANT_SOURCE-3-69"
    } else if (sourceSiteURL?.toLowerCase()?.includes("facebook")) {
      sourceResult = "Facebook"
    } else if (sourceSiteURL?.toLowerCase()?.includes("tiktok")) {
      sourceResult = "APPLICANT_SOURCE-3-41"
    } else if (sourceSiteURL?.toLowerCase()?.includes("instagram")) {
      sourceResult = "Instagram"
    } else {
      sourceResult = "Company_Website"
    }
  }
  return `source=${sourceResult}`
}

export const getUTMParams = searchParams => {
  const urlParams = new URLSearchParams(searchParams)
  const utmSource = urlParams.get("utm_source")
  const utmMedium = urlParams.get("utm_medium")
  const utmCampaign = urlParams.get("utm_campaign")
  const utmTerm = urlParams.get("utm_term")
  const utmContent = urlParams.get("utm_content")
  let utmParams = ""
  if (utmSource) utmParams += `&utm_source=${utmSource}`
  if (utmMedium) utmParams += `&utm_medium=${utmMedium}`
  if (utmCampaign) utmParams += `&utm_campaign=${utmCampaign}`
  if (utmTerm) utmParams += `&utm_term=${utmTerm}`
  if (utmContent) utmParams += `&utm_content=${utmContent}`
  if (utmParams.startsWith("&")) {
    utmParams = utmParams.slice(1)
  }
  return utmParams
}